import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ResponseTranslation, TranslationLangKey } from '../models/Translations';

@Injectable({ providedIn: 'root' })
export class LocalHelperService {
  private translateService = inject(TranslateService);

  getLocalizedValue(value: ResponseTranslation | null | undefined): string {
    if (!value) return '';

    const lang =
      (this.translateService.currentLang as TranslationLangKey) || (this.translateService.getDefaultLang() as TranslationLangKey);

    return value[lang] || value.en || '';
  }
}
